/**
 * FORMULÁRIO DE ESTRATÉGIA COM IA - GROWLY
 * Gera estratégias de marketing usando OpenAI
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiLoader, FiCheckCircle } from 'react-icons/fi';
import './StrategyForm.css';

const StrategyForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    businessType: '',
    targetAudience: '',
    goals: '',
    currentChallenges: ''
  });

  const [loading, setLoading] = useState(false);
  const [strategy, setStrategy] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const generateStrategy = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setStrategy('');

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        setError('Sessão expirada. Faça login novamente.');
        navigate('/login');
        return;
      }

      const response = await fetch('https://growly-test-production.up.railway.app/api/ai/generate-strategy', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setStrategy(data.strategy);

        window.dispatchEvent(new Event('campaignCreated'));

        if (window.dashboardRefresh) {
          window.dashboardRefresh();
        }

      } else {
        setError(data.error || 'Erro ao gerar estratégia');
      }

    } catch (error) {
      console.error('Erro ao gerar estratégia:', error);
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="strategy-page">
      <div className="strategy-form-container">
        <div className="strategy-header">
          <button onClick={() => navigate('/dashboard')} className="back-btn">
            <FiArrowLeft size={18} /> Voltar ao Dashboard
          </button>
          <h1>Gerador de Estratégia com IA</h1>
          <p>Preencha os campos abaixo para receber uma estratégia de marketing personalizada para o seu negócio</p>
        </div>

        <div className="strategy-content">
          <form onSubmit={generateStrategy} className="strategy-form">

            <div className="form-group">
              <label htmlFor="businessType">Tipo de Negócio *</label>
              <select
                id="businessType"
                name="businessType"
                value={formData.businessType}
                onChange={handleInputChange}
                required
              >
                <option value="">Selecione o tipo de negócio</option>
                <option value="ecommerce">E-commerce</option>
                <option value="servicos">Prestação de Serviços</option>
                <option value="saas">Software/SaaS</option>
                <option value="consultoria">Consultoria</option>
                <option value="educacao">Educação</option>
                <option value="saude">Saúde</option>
                <option value="outro">Outro</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="targetAudience">Público-Alvo *</label>
              <textarea
                id="targetAudience"
                name="targetAudience"
                value={formData.targetAudience}
                onChange={handleInputChange}
                placeholder="Ex: Mulheres de 25 a 40 anos interessadas em bem-estar, estética e vida saudável."
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="goals">Principais Objetivos *</label>
              <textarea
                id="goals"
                name="goals"
                value={formData.goals}
                onChange={handleInputChange}
                placeholder="Ex: Aumentar vendas em 50%, gerar mais leads qualificados, melhorar presença digital..."
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="currentChallenges">Principais Desafios</label>
              <textarea
                id="currentChallenges"
                name="currentChallenges"
                value={formData.currentChallenges}
                onChange={handleInputChange}
                placeholder="Ex: Baixo engajamento, dificuldade de converter leads, orçamento limitado..."
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" disabled={loading} className="generate-btn">
              {loading ? (
                <>
                  <FiLoader className="animate-spin" size={18} />
                  Gerando estratégia...
                </>
              ) : (
                'Gerar Estratégia com IA'
              )}
            </button>
          </form>

          {strategy && (
            <div className="strategy-result">
              <div className="success-message">
                <FiCheckCircle size={20} />
                Estratégia gerada e salva com sucesso!
              </div>
              <h2>Sua Estratégia Personalizada</h2>

              <div className="strategy-result-content">
                <pre>{strategy}</pre>
              </div>

              <div className="strategy-actions">
                <button
                  onClick={() => navigate('/dashboard')}
                  className="save-btn"
                >
                  Ver no Dashboard
                </button>
                <button
                  onClick={() => setStrategy('')}
                  className="clear-btn"
                >
                  Gerar Nova Estratégia
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default StrategyForm;
